var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip', {
    staticClass: "font-weight-bold tag-chip",
    "class": _vm.chipClass,
    attrs: {
      "small": _vm.size === 'small',
      "color": _vm.tagColor,
      "text-color": _vm.tagTextColor,
      "close": _vm.closable
    },
    on: {
      "click:close": function clickClose($event) {
        return _vm.$emit('close', _vm.tag);
      }
    },
    nativeOn: {
      "mousedown": function mousedown($event) {
        return _vm.onChipMouseDown.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.tagName) + " ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }